import React from "react";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { DataGrid } from '@mui/x-data-grid';
import TsvUploader from "../../../components/TsvUploader";
import GPAP_Button from "../../../../../gpap-lib/Button_Collection";
import { downloadCSV, CsvButton } from '../../../../service/CsvButton';


const ExperimentBatchTable =(props)=>{

    const getCsvExperimentsBatch = (event) => {
        const tableHeader = props.columns.filter((header)=> header.field !== 'id');
        const csvHeader = tableHeader.map((header) => ({label: header.headerName, key: header.field})); 
        downloadCSV(props.rows,csvHeader,"experiments_to_update.csv");
    }


    return(
        <Grid 
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item >
                <Grid 
                    container 
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="flex-start"
                >
                    <Grid item sx={{m:1}}> 
                        <TsvUploader uploadTsv={props.uploadTsv}/>
                    </Grid>
                    <Grid item sx={{m:1}}>
                        <GPAP_Button id="update"  startIcon={<CloudUploadIcon />} onClick={props.updateExperiments}>
                            Confirm Experiment Batch Edition
                        </GPAP_Button>  
                    </Grid>
                </Grid>
            </Grid>
            <Grid item >
                <Box
                    sx={{
                        width: 1200,
                        height: 600
                    }}
                >
                    <DataGrid
                        rows={props.rows}
                        columns={props.columns}
                        pageSize={props.pageSize}
                        rowsPerPageOptions={[props.pageSize]}
                    />

                    <CsvButton getCsvData={getCsvExperimentsBatch} />
                </Box>
            </Grid>
        </Grid>
    );
}

export default ExperimentBatchTable;
